import { MenuItem } from "@chakra-ui/react";

import type { ReactElement } from "react";

interface MobileNavButtonProps {
	label: string;
	route: string;
	icon: ReactElement;
}

export const MobileNavButton = (props: MobileNavButtonProps) => {
	const { label, route, icon } = props;

	return (
		<MenuItem
			onClick={() => window.location.replace(`/#${route}`)}
			_hover={{ color: "brand.contrast", bg: "brand.light" }}
			fontFamily="Kalnia Variable"
			color="brand.dark"
			icon={icon}
		>
			{label.toUpperCase()}
		</MenuItem>
	);
};
